import React from 'react';
import { Spin } from 'antd';
import styles from './index.less';

const Loading = ({ className = '', tip = null }) => (
  <div className={`${styles.wrapper} ${className}`}>
    <Spin tip={tip} />
  </div>
);

export default Loading;
